"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentsTelemetry = void 0;
var inversify_react_1 = require("inversify-react");
var react_1 = require("react");
var usePaymentSettings_1 = require("./PaymentSettings/usePaymentSettings");
var AccountTelemetryHelper_1 = require("@CommonFrontendBackend/Telemetry/AccountTelemetryHelper");
var PaymentsTelemetry = function () {
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var settings = (0, usePaymentSettings_1.usePaymentSettings)().settings;
    return (0, react_1.useMemo)(function () {
        var paymentsDashboardOpened = function (eventOrigin, numberOfConnectedGateways, currentGatewayCountry) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.PaymentsDashboardOpened,
                        eventProperties: {
                            enabled: settings.enabled,
                            numberOfConnectedGateways: numberOfConnectedGateways,
                            currentGatewayCountry: currentGatewayCountry || "none",
                        },
                        eventOrigin: eventOrigin,
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var currentGatewayChanged = function (eventOrigin, numberOfConnectedGateways, newGatewayCountry) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.CurrentGatewayChanged,
                        eventProperties: {
                            enabled: settings.enabled,
                            numberOfConnectedGateways: numberOfConnectedGateways,
                            currentGatewayCountry: newGatewayCountry,
                        },
                        eventOrigin: eventOrigin,
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var settingsModalOpened = function (eventOrigin) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.SettingsModalOpened,
                        eventProperties: {},
                        eventOrigin: eventOrigin,
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var qwilrPayWidgetOpened = function (numberOfConnectedGateways) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.QwilrPayWidgetOpened,
                        eventProperties: {
                            enabled: settings.enabled,
                            numberOfConnectedGateways: numberOfConnectedGateways,
                        },
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var onboardingModalOpened = function (eventOrigin) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.OnboardingModalOpened,
                        eventProperties: {},
                        eventOrigin: eventOrigin,
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var onboardingModalClosed = function (eventOrigin) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.OnboardingModalClosed,
                        eventProperties: {},
                        eventOrigin: eventOrigin,
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        var countrySelected = function (onboardingCountryCode) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    serverTelemetry.sendPaymentsTelemetry({
                        eventName: AccountTelemetryHelper_1.PaymentsEventName.OnboardingModalClosed,
                        eventProperties: {
                            onboardingCountryCode: onboardingCountryCode,
                        },
                    });
                }
                catch (e) {
                    console.error("Failed to send telemetry to the server", e);
                }
                return [2];
            });
        }); };
        return {
            paymentsDashboardOpened: paymentsDashboardOpened,
            currentGatewayChanged: currentGatewayChanged,
            settingsModalOpened: settingsModalOpened,
            qwilrPayWidgetOpened: qwilrPayWidgetOpened,
            onboardingModalOpened: onboardingModalOpened,
            onboardingModalClosed: onboardingModalClosed,
            countrySelected: countrySelected,
        };
    }, [serverTelemetry]);
};
exports.PaymentsTelemetry = PaymentsTelemetry;
